import { render, staticRenderFns } from "./view21.vue?vue&type=template&id=85577b26&scoped=true&"
import script from "./view21.vue?vue&type=script&lang=js&"
export * from "./view21.vue?vue&type=script&lang=js&"
import style0 from "./view21.vue?vue&type=style&index=0&id=85577b26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85577b26",
  null
  
)

export default component.exports